import { Button } from "@/ds/shadcn/components/ui/button";
import { HeaderBar } from "@/features/common/components/HeaderBar";
import { HeaderBarSelector } from "@/features/common/components/HeaderBarSelector";
import { HeaderBarTools } from "@/features/common/components/HeaderBarTools";
import { HeightExpander } from "@/features/common/components/HeightExpander";
import { useProduct } from "@/features/products/api/useProduct";
import { ProductView } from "@/features/products/components/ProductView";
import { useTitle } from "@/lib/common/useTitle";
import { ChartHistoryDurationOptions } from "@/lib/domain/ChartHistoryDuration";
import { getAffiliateLink } from "@/lib/domain/getAffiliateLink";
import { useUserPreferencesState } from "@/lib/state/UserPreferencesState";
import { ExternalLinkIcon, TimerIcon } from "lucide-react";
import { useMemo, type FC } from "react";
import { Link, useParams } from "react-router";

export const PageProduct: FC = () => {
	const params = useParams();
	const productId = params.productId as string;

	const product = useProduct(productId);
	const title = useMemo(() => !product.data ? "Product" : product.data.name, [product.data]);
	const description = useMemo(() => product.data?.number ? product.data.number.toUpperCase() : "Sealed Product", [product.data]);
	const affiliateLink = useMemo(() => product.data ? getAffiliateLink(product.data.tcgPlayerProductId) : null, [product.data]);

	useTitle(title);

	const { state, dispatchSetChartHistoryDuration } = useUserPreferencesState();

	const breadcrumb = useMemo(() => [
		{ label: "Dashboard", href: "/dashboard" },
		{ label: "Products" },
		!product.data ? { label: "Product" } : { label: product.data.name }
	], [product.data]);

	return (
		<>
			<HeaderBar title={title} description={description} breadcrumb={breadcrumb} />
			<HeaderBarTools>
				<HeaderBarSelector
					value={state.chartHistoryDuration}
					onChange={dispatchSetChartHistoryDuration}
					placeholder="Time Range"
					icon={TimerIcon}
					options={ChartHistoryDurationOptions} />
				{
					affiliateLink &&
					<Button variant="outline" className="w-full" asChild>
						<Link to={affiliateLink} target="_blank" rel="noopener noreferrer">
							<ExternalLinkIcon />
							View on TCGplayer
						</Link>
					</Button>
				}
			</HeaderBarTools>
			<HeightExpander className="flex flex-col @md:flex-row">
				<ProductView productId={productId} hideChartHistoryDurationSelector />
			</HeightExpander>
		</>
	);
};
